// İSG Portal — auth-gated route guard.
//
// Oturum yoksa `redirectTo`'ya (login) yönlendirir; oturum varsa alt route'ları
// (`Outlet`) veya `children`'ı render eder. Store rehydrate edilene kadar (`idb`
// async) hiçbir karar verilmez — aksi hâlde geçerli oturum bir an login'e atılır.

import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../auth/store';

interface RequireAuthProps {
  /** Oturum yoksa yönlendirilecek yol. */
  redirectTo?: string;
  /** Rehydrate beklenirken gösterilecek içerik (varsayılan: boş). */
  fallback?: ReactNode;
  children?: ReactNode;
}

export function RequireAuth({
  redirectTo = '/login',
  fallback = null,
  children,
}: RequireAuthProps) {
  const hasHydrated = useAuthStore((s) => s.hasHydrated);
  const authenticated = useAuthStore((s) => s.accessToken !== null);
  const location = useLocation();

  if (!hasHydrated) {
    return <>{fallback}</>;
  }

  if (!authenticated) {
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
  }

  return children ? <>{children}</> : <Outlet />;
}

/**
 * Ters guard — oturum AÇIKKEN login/parola ekranlarına gelen kullanıcıyı
 * uygulamaya (`redirectTo`) geri yollar.
 */
export function RedirectIfAuthenticated({
  redirectTo = '/',
  children,
}: {
  redirectTo?: string;
  children: ReactNode;
}) {
  const hasHydrated = useAuthStore((s) => s.hasHydrated);
  const authenticated = useAuthStore((s) => s.accessToken !== null);

  if (hasHydrated && authenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
